import React from "react";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import CustomAccordian from "../../../components/CustomAccordian";

const faqData = [
  {
    title: "What is a cryptocurrency exchange?",
    description: `A cryptocurrency exchange is a platform that allows you to sell, purchase, trade, and store digital
         currencies like Bitcoin, Ethereum, and Tether. The Tarality Exchange is the best and safest place to start your
        cryptocurrency trading journey.`,
  },
  {
    title: "What if I get stuck while trading?",
    description: `At Tarality, we are always ready to help you. Our dedicated customer support team is available to clear all
    your doubts and help you if you get stuck or encounter any problems.`,
  },
  {
    title: "How do I start trading on Tarality?",
    description: `To start your trading journey with Tarality, you need to create an account by simply signing up and
    completing identity verification, for which you need to provide proof of identity (e.g., passport, Aadhar card,
    driving license) and your photograph. Additional documents may be required in certain cases. That's it. After
    that, you can simply start trading.`,
  },
  {
    title: "Is it safe to invest in crypto through Tarality?",
    description: `Yes, Trading with Tarality is safe. We employ strong security measures and comply with regulations. However, remember these 5 keypoints.
    1. Understand the Risks & Rewards
    2. Research Matters
    3. Keep your Information Secure
    4. Diversify your Investments
    5. Subscribe our newsletter and stay updated yourself with latest crypto market trends/news.
    `,
  },
];

const faqDataRight = [
  {
    title: "Is my data safe on Tarality?",
    description: `You need not worry about your personal information, as it will always be protected and used only for legal
    and compliance purposes.`,
  },
  {
    title:
      "How do I buy Bitcoin, Taral, or other cryptocurrencies on Tarality?",
    description: `It is very easy to use Tarality to buy cryptocurrencies. You might simply use a credit or debit card or any
    other payment method of your choice.`,
  },
  {
    title:
      "How long does it take to receive my cryptocurrency after I buy it on Tarality?",
    description: `The time it takes to receive your cryptocurrency after you buy it on Tarality depends on the cryptocurrency
    you buy and the payment method you use. For example, If you purchase Bitcoin using a credit or debit card,
    you will receive it instantly.`,
  },
  {
    title: "Why you should choose Tarality?",
    description: `Choosing Tarality as your Crypto Exchange Platform comes with several benefits that make your trading experience secure, efficient, and user-friendly. We have; User-friendly Interface, Diverse Asset Selection, Fast & Reliable Transactions, and Responsive Customer Support. `,
  },
];

export default function Faq() {
  return (
    <Box className="mainContainer" sx={{ marginBottom: "80px" }}>
      <Box mb={2}>
        <Typography variant="h2">Frequently Asked Questions</Typography>
      </Box>

      <Grid container spacing={1}>
        <Grid item lg={6} sm={12} md={6} xs={12}>
          <Grid container spacing={1}>
            {faqData &&
              faqData.map((item, i) => {
                return (
                  <Grid item lg={12} xs={12} key={`faqLeft${i}`}>
                    <CustomAccordian item={item} type="faq" />
                  </Grid>
                );
              })}
          </Grid>
        </Grid>

        <Grid item lg={6} sm={12} md={6} xs={12}>
          <Grid container spacing={1}>
            {faqDataRight &&
              faqDataRight.map((item, i) => {
                return (
                  <Grid item lg={12} xs={12} key={`faqRight${i}`}>
                    <CustomAccordian item={item} type="faq" />
                  </Grid>
                );
              })}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
